import React, { createContext, useContext, useEffect, useState } from 'react';
import { generateNonce, setNonce } from '../utils/nonce';

export const NonceContext = createContext<string>('');

export const useNonce = () => useContext(NonceContext);

export const NonceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [nonceValue, setNonceValue] = useState<string>('');

  useEffect(() => {
    const nonce = generateNonce();
    setNonce(nonce);
    setNonceValue(nonce);
  }, []);

  return <NonceContext.Provider value={nonceValue}>{children}</NonceContext.Provider>;
};
